import type { ReactNode } from 'react'

import { Container } from './Container'
import { IconWrapper } from './IconWrapper'
import { Title } from './Title'

type Props = {
	icon: ReactNode
	title: ReactNode
	children: ReactNode

	isHighlighted?: boolean
}

export const OrderedItem = ({ icon, title, children, isHighlighted = false }: Props) => (
	<Container>
		<IconWrapper isHighlighted={isHighlighted}>{icon}</IconWrapper>
		<div>
			<Title>{title}</Title>
			{children}
		</div>
	</Container>
)
